module.exports = __webpack_public_path__ + "img/AI.96e24e9e.svg";